
import $_ from 'lodash'

// Array
export const chunk = $_.chunk
export const difference = $_.difference
export const findIndex = $_.findIndex
export const join = $_.join
export const uniq = $_.uniq
export const intersection = $_.intersection


// Collection
export const filter = $_.filter
export const sortBy = $_.sortBy
export const find = $_.find
export const set = $_.set

// Function
export const debounce = $_.debounce
export const throttle = $_.throttle

// Lang
export const cloneDeep = $_.cloneDeep
export const isArray = $_.isArray
export const isEmpty = $_.isEmpty
export const isEqual = $_.isEqual
export const isNull = $_.isNull
export const isObject = $_.isObject
export const isString = $_.isString
export const isUndefined = $_.isUndefined

// Object
export const result = $_.result
export const get = $_.get
export const merge = $_.merge
export const omit = $_.omit
export const pick = $_.pick
export const assignIn = $_.assignIn

// String
export const camelCase = $_.camelCase
export const capitalize = $_.capitalize
export const trim = $_.trim
export const upperFirst = $_.upperFirst
